import { InvoiceLinesBus } from "./InvoiceLinesBus";

export class InvoiceLinesSaveParam  {
    invoiceId: any;
    lineItems: InvoiceLinesBus[];
    lineItemsCORR: InvoiceLinesBus[];
    lineItemsCORR2: InvoiceLinesBus[];
    code: string;
    customerId: any;
    locationId: any;
    customerId2: any;
    locationId2: any;
    labor: number;
    material: number;
    other: number;
    tax: number;
    isTaxOnly: boolean;
    isTaxable: boolean;
}
